import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

interface AccordianProps {
  title: string;
  isActive?: boolean;
  children: React.ReactNode;
  isHeightFull?: boolean;
  isOpen:boolean;
  setIsOpen: any;
}
const Accordian: React.FC<AccordianProps> = ({
  isActive,
  title,
  children,
  isOpen = true,
  setIsOpen,
  isHeightFull = false,
}) => {
  return (
    <div
      className="accordian"
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="accordian-header"
      >
        <span className="accordian-title">{title}</span>
        <FontAwesomeIcon
          size="2x"
          style={{ marginTop: 2, cursor: "pointer", fontSize: "12px" }}
          icon={isOpen ? faChevronUp : faChevronDown}
        />
      </div>
      {isOpen && (
        <div
        className="accordian-body"
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordian;
